// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAZTLdtgBHtDpKEPGkKD-xDDzet8eM7ggM",
    authDomain: "healthcare-related-websi-1832f.firebaseapp.com",
    projectId: "healthcare-related-websi-1832f",
    storageBucket: "healthcare-related-websi-1832f.appspot.com",
    messagingSenderId: "897066635864",
    appId: "1:897066635864:web:627e6746f7edb315dc302d"
  };

  export default firebaseConfig;